export default __webpack_public_path__ + "static/section_4_details_9-a6f22eb1c076bb3e365f8b764f4488b5.png";